import { memo } from 'react';
import {
  normalizeSignatureAnswer,
  signatureCanvasViewBox,
  signatureStrokePath,
} from '../../lib/question-blocks';

/** Render canonical or legacy drawn ink without exposing executable markup. */
function SignaturePreviewComponent({ value }: { value: unknown }): React.ReactElement | null {
  const signature = normalizeSignatureAnswer(value);
  if (signature?.kind !== 'drawn') return null;
  return <svg role="img" aria-label="Drawn signature" viewBox={signatureCanvasViewBox(signature)}
    width={signature.canvas.width} height={signature.canvas.height}
    className="mt-3 h-auto max-h-48 w-full max-w-md rounded-lg bg-surface text-foreground"
    style={{ aspectRatio: `${signature.canvas.width} / ${signature.canvas.height}` }}>
    {signature.strokes.map((stroke, index) => <path key={index} d={signatureStrokePath(signature, stroke)}
      fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />)}
  </svg>;
}

/** Shared memoized drawn-signature preview for review surfaces. */
export const SignaturePreview = memo(SignaturePreviewComponent);
